import {
  SUBDIVISIONS_LOADING,
  SUBDIVISIONS_SUCCESS,
  SUBDIVISIONS_ERROR,
} from '../actions/subDivisionAction';

const initialState = {
  subDivisions: [],
  loading: false,
  error: null,
};

export default function subDivisions(state = initialState, action = {}) {
  switch (action.type) {
    case SUBDIVISIONS_LOADING:
      return { ...state, loading: true, error: null };
    case SUBDIVISIONS_SUCCESS:
      return { ...state, loading: false, subDivisions: action.payload || [] };
    case SUBDIVISIONS_ERROR:
      return { ...state, loading: false, error: action.error || 'Error' };
    default:
      return state;
  }
}
